import GDAFiltersList from './GDAFiltersList';
export default GDAFiltersList;
